
import vSelect from './vselect'
import common from '@/tools/common'
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Selector from 'vux/src/components/selector/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'


export default {
directives: {
TransferDom
},
components: {
vSelect,
Divider,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
FlexboxItem,
XTable,
Popup,
Selector,
Alert,
XDialog
},
methods: {
async doQuery() {

if (this.business === 0 || this.business === '') {
this.$vux.alert.show({
title: '提示', content: '请选择业务领域！'
})
return
}
let user_name = common.getNodeSession();
this.$router.push({
name: 'NodeSearchByDataDetails',
params: {
user_name: user_name,
enumtype: this.$route.query.code,
keyword: this.keyword,
businessType: this.businessType,
nodeName: this.nodeName,
node: this.node,
post: this.post,
secondPost: this.secondPost,
firstPost: this.firstPost,
business: this.business
}
})
},
async getYears() {
const queryPromise = await this.$http.get('/API/NodeSearch/GetTableName?enumtype=' + this.$route.query.code)
return queryPromise.data
},
async getBusiness() {
if(this.business == ''){
this.businessTypeList = []
return
}
const queryPromise = await this.$http.get('/API/NodeSearch/GetYWLX?enumtype=' + this.$route.query.code + '&tablename=' + this.business)
this.businessTypeList = (queryPromise.data).sort().reverse()
if (this.businessTypeList.length > 0) {
this.businessTypeList.unshift('')
this.businessType = this.businessTypeList[0]
}
},
async getBusinessType() {
if(this.businessType == ''){
this.nodeNameList = []
return
}
const queryPromise = await this.$http.get('/API/NodeSearch/GetYWHJ?enumtype=' + this.$route.query.code + '&tablename=' + this.businessType)
this.nodeNameList = (queryPromise.data).sort().reverse()
if (this.nodeNameList.length > 0) {
this.nodeNameList.unshift('')
this.nodeName = this.nodeNameList[0]
}
},
clear() {
this.keyword = ''
this.nodeName = ''
this.businessType = ''
this.businessTypeList = []
this.nodeNameList = []
this.business = ''
this.post = ''
this.secondPost = ''
this.firstPost = ''
this.node = ''

},
async getTableName() {
let no = this.$route.query.code
this.tableindex = no
const queryPromise = await this.$http.get('/API/NodeSeach/NodeNameByNo'
, {params: {no: no}})
console.log(queryPromise)
this.tablename = queryPromise.data.G_NAME
}
},
data() {
return {
tableindex: 1,
tablename: '',
business: '',
keyword: '',
post: '',
firstPost: '',
secondPost: '',
node: '',
nodeName: '',
businessType: '',
businessList: [
{businesses: '', ID: ''}
],
businessTypeList: [
{businessTypes: '', ID: ''}
],
nodeNameList: [
{nodeNames: '', ID: ''}
]
}
},
async activated() {
this.getTableName()
this.businessList = (await this.getYears()).sort().reverse()
if (this.businessList.length > 0) {
this.businessList.unshift('')
this.business = this.businessList[0]
}
}
}



// WEBPACK FOOTER //
// ./src/components/NodeSearchByDataQuery.vue